import { useRef } from 'react';
const useInstitutionFormRefs = () => {
    const orderedRefs = [
        ['name', useRef(null)],
        ['email', useRef(null)],
        ['password', useRef(null)],
        ['confirmPassword', useRef(null)],
        ['approvalStatus', useRef(null)],
        ['approvalMessage', useRef(null)],
        ['emailLanguage', useRef(null)],
    ];
    return { refs: Object.fromEntries(orderedRefs), orderedRefs };
};
export default useInstitutionFormRefs;
